// src/shared/rota-wait.js - the AI rota's waiting, made visible and bounded (v133.94).
//
// Matt, 9 Oct 2026: "When i tried to use it live it froze." Generating makes up to three AI calls in a row
// (reading the notes, the rota, then a "refining" pass when the first draft breaks a rule), each of which can
// take a minute or more, with only three moving dots on screen and no time limit: it looked frozen, and a call
// that never came back stayed frozen. Now the wait counts up on screen, each call has a hard limit, and the
// generators skip the refining pass when the first call was already slow.

export const AI_CALL_LIMIT_MS = 120000;     // one rota call
export const AI_NOTES_LIMIT_MS = 45000;     // reading the manager's notes (fail-soft: generation carries on)
export const AI_SKIP_REFINE_SECS = 60;      // a first call slower than this: keep its draft, no second pass

// A promise that gives up after `ms` with `message` (the request itself may still finish in the background;
// its answer is simply not waited for).
export function withTimeout(promise, ms, message) {
  let timer;
  const limit = new Promise((resolve, reject) => { timer = setTimeout(() => reject(new Error(message)), ms); });
  return Promise.race([promise, limit]).finally(() => clearTimeout(timer));
}

// The status line counts up while it waits. dots: the generator's own dot markup. -> { setLabel, secs, stop }
export function startTicker(el, dots, label) {
  const t0 = Date.now();
  let text = label;
  const secs = () => Math.round((Date.now() - t0) / 1000);
  const paint = () => { if (el) el.innerHTML = dots + ' ' + text + ' <span style="opacity:.75">(' + secs() + 's, this can take up to two minutes)</span>'; };
  paint();
  const id = setInterval(paint, 1000);
  return { setLabel(t) { text = t; paint(); }, secs, stop() { clearInterval(id); } };
}

export const TOO_SLOW = 'The AI took more than two minutes, so it was stopped. Nothing was changed: please try again in a moment.';
